export default "__VITE_ASSET__BX3at6O5__"